import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#trainee_reassessment",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Trainee Reassessment")
  ])
], -1)
const _hoisted_3 = {
  id: "trainee_reassessment",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institute", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "row mt-4" }
const _hoisted_18 = { class: "col-md-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course Name", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Batch", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "card mb-5 mb-xl-10" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#assessment_info",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Reassessment Information")
  ])
], -1)
const _hoisted_27 = {
  id: "assessment_info",
  class: "collapse show"
}
const _hoisted_28 = { class: "collapse show" }
const _hoisted_29 = { class: "card-body border-top p-9" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", {
  class: "current",
  "data-kt-stepper-element": "content"
}, null, -1)
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Assessment Title", -1)
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "col-md-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Total Training Days", -1)
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "card mb-5 mb-xl-10" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#assessment_list",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Training Reassessment")
  ])
], -1)
const _hoisted_40 = {
  id: "assessment_list",
  class: "collapse show"
}
const _hoisted_41 = { class: "collapse show" }
const _hoisted_42 = { class: "card-body border-top p-9" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", {
  class: "current",
  "data-kt-stepper-element": "content"
}, null, -1)
const _hoisted_44 = { class: "table-responsive mt-5" }
const _hoisted_45 = { class: "table table-borderless gy-4" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Action"),
    /*#__PURE__*/_createElementVNode("th", null, "Photo"),
    /*#__PURE__*/_createElementVNode("th", null, "Reference No"),
    /*#__PURE__*/_createElementVNode("th", null, "Registration No"),
    /*#__PURE__*/_createElementVNode("th", null, "Trainee Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Assessment Date"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"160px"} }, "Reassessment Date"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"160px"} }, "Assessor"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"160px"} }, "Competency")
  ])
], -1)
const _hoisted_47 = { style: {} }
const _hoisted_48 = {
  key: 0,
  style: {"border-bottom":"1px solid rgba(29, 182, 140, 0.51)"}
}
const _hoisted_49 = { class: "align-middle" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "text-light" }, "Confirm", -1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = ["src"]
const _hoisted_54 = { class: "align-middle" }
const _hoisted_55 = { class: "align-middle" }
const _hoisted_56 = { class: "align-middle" }
const _hoisted_57 = { class: "align-middle" }
const _hoisted_58 = { class: "align-middle" }
const _hoisted_59 = { class: "align-middle" }
const _hoisted_60 = { class: "align-middle" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle fs-3 text-danger" }, null, -1)
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Tranche",
                    modelValue: _ctx.trainee.tranche_id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainee.tranche_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: trans.id,
                          label: trans.label,
                          value: trans.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(trans.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _hoisted_13,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Partner",
                    modelValue: _ctx.trainee.entity_id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.trainee.entity_id) = $event)),
                    filterable: "",
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.trainingInstitute())),
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associations, (assoc) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: assoc.id,
                          label: assoc.entity_short_name,
                          value: assoc.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("[" + _toDisplayString(assoc.entity_short_name) + "]-" + _toDisplayString(assoc.entity_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _hoisted_16,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Institute",
                    modelValue: _ctx.trainee.training_institute_id,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.trainee.training_institute_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getCourseList()))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.institutes, (inst) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: inst.id,
                          label: inst.institute_name,
                          value: inst.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(inst.institute_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _hoisted_20,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    "collapse-tags": "",
                    placeholder: "Select Course",
                    modelValue: _ctx.trainee.course_info_id,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.trainee.course_info_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getBatchList()))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: course.id,
                          label: course.course_name,
                          value: course.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(course.course_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _hoisted_23,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    "collapse-tags": "",
                    placeholder: "Select Batch",
                    modelValue: _ctx.trainee.batch_info_id,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.trainee.batch_info_id) = $event)),
                    filterable: "",
                    onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.checkAssessmentEligiblity())),
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batches, (batch) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: batch.id,
                          label: batch.batch_sequence_number,
                          value: batch.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(batch.batch_sequence_number), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.load]
      ])
    ]),
    (_ctx.showAssessmentList == true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        readonly: "",
                        value: _ctx.textAssessment
                      }, null, 8, _hoisted_34)
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        readonly: "",
                        value: _ctx.courseInfo?.day
                      }, null, 8, _hoisted_37)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showAssessmentList == true)
      ? (_openBlock(), _createElementBlock("div", { key: _ctx.assessmentkey }, [
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("table", _hoisted_45, [
                      _hoisted_46,
                      _createElementVNode("tbody", _hoisted_47, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.traineeList, (data, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            (data?.training_assessment?.assessment_score != 100)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_48, [
                                  _createElementVNode("td", _hoisted_49, [
                                    (data.attendance_percentage >= 80)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          onClick: ($event: any) => (_ctx.Approve(index, data.id)),
                                          title: "Confirm",
                                          class: "btn btn-bg-success btn-active-color-success btn-sm"
                                        }, _hoisted_52, 8, _hoisted_50))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("img", {
                                      src: 
                            _ctx.api_url + data?.attach_file_info?.file_path
                          ,
                                      alt: "",
                                      width: "32",
                                      height: "32"
                                    }, null, 8, _hoisted_53)
                                  ]),
                                  _createElementVNode("td", _hoisted_54, _toDisplayString(data?.reference_number), 1),
                                  _createElementVNode("td", _hoisted_55, _toDisplayString(data?.registration_number), 1),
                                  _createElementVNode("td", _hoisted_56, _toDisplayString(data?.trainee_name), 1),
                                  _createElementVNode("td", _hoisted_57, _toDisplayString(data?.training_assessment?.assessment_date), 1),
                                  _createElementVNode("td", _hoisted_58, [
                                    (
                            data?.training_assessment?.assessment_score == 50 ||
                            data?.training_assessment?.assessment_score == 0
                          )
                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                          key: 0,
                                          prop: "date",
                                          class: "mb-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_date_picker, {
                                              modelValue: _ctx.assessment[index].reassessment_date,
                                              "onUpdate:modelValue": ($event: any) => ((_ctx.assessment[index].reassessment_date) = $event),
                                              name: `reassessment_date[${index}]`,
                                              "value-format": "YYYY-MM-DD",
                                              format: "DD-MM-YYYY",
                                              type: "date",
                                              style: {"width":"100%"}
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("td", _hoisted_59, [
                                    (
                            data?.training_assessment?.assessment_score == 0 ||
                            data?.training_assessment?.assessment_score == 50
                          )
                                      ? (_openBlock(), _createBlock(_component_el_select, {
                                          key: 0,
                                          class: "form-select-solid",
                                          placeholder: "Select Assessor",
                                          modelValue: _ctx.assessment[index].assessor_info_id,
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.assessment[index].assessor_info_id) = $event),
                                          name: `competency[${data.id}]`,
                                          filterable: "",
                                          style: {"width":"100%"}
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assessors, (assessor) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: assessor.id,
                                                label: assessor?.employee_info?.name,
                                                value: assessor.id
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(assessor?.employee_info?.name), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue", "name"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("td", _hoisted_60, [
                                    (
                            data?.training_assessment?.assessment_score == 0 ||
                            data?.training_assessment?.assessment_score == 50
                          )
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          (data.attendance_percentage < data?.batch_info?.dropout_below_perc)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, _hoisted_63))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                                _createVNode(_component_el_select, {
                                                  class: "form-select-solid",
                                                  placeholder: "Select competency",
                                                  modelValue: _ctx.assessment[index].competency,
                                                  "onUpdate:modelValue": ($event: any) => ((_ctx.assessment[index].competency) = $event),
                                                  name: `competency[${data.id}]`,
                                                  filterable: "",
                                                  style: {"width":"100%"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_option, {
                                                      label: "Competent",
                                                      value: "100"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("Competent")
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_el_option, {
                                                      label: "Not Competent",
                                                      value: "-1"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("Not Competent")
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_el_option, {
                                                      label: "Absent",
                                                      value: "0"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("Absent")
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 2
                                                }, 1032, ["modelValue", "onUpdate:modelValue", "name"])
                                              ]))
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}